import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { LoginModel } from 'src/app/models/login.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { faX} from '@fortawesome/free-solid-svg-icons'; // O far para regular

@Component({
  selector: 'app-shipping-policy',
  templateUrl: './shipping-policy.component.html',
  styleUrls: ['./shipping-policy.component.scss']
})
export class ShippingPolicyComponent {
  @Input() title = '';
  @Input() msg = '';
  @Input() btn_msg_yes = '';
  @Input() btn_msg_no = '';
  @Input() callback_yes = () => {};
  @Input() callback_no = () => {};
  loginFormGroup: RxFormGroup;
  isLogin = false;
  faClose= faX;
  typePassword: boolean = true; // Or initialize as needed
  modalCarga?: NgbModalRef;
  ngbModalOptions: NgbModalOptions = {
    backdropClass: 'modal-backdrop-blur',
    backdrop: 'static',
    keyboard: false,
    centered: true,
  };
  constructor(public activeModal: NgbActiveModal
  ) {}

  async ngOnInit(): Promise<void> {
  }

  public close() {
    this.activeModal.close('login');
    this.callback_yes();
  }
}

 